import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/iFrame';

const iFrameReducer = (state = GlobalState().iFrame, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.GET_IFRAME_SOURCE) {
    } else if (action.type === Actions.actions.SET_IFRAME_SOURCE) {
        const iFrameSourceActionPayload = action as any;
        const iFrameSource = iFrameSourceActionPayload.returnUrl ? iFrameSourceActionPayload.returnUrl : [];
        newState.iFrameSource = iFrameSource;
    }
    return Object.assign({}, state, newState);
};

export default iFrameReducer;
